import { CommonUtilities } from "../../commonUtils";
import React, { Suspense, useState, useEffect } from "react";
import projectServices from "./projectServices";
import Pagination from "components/Common/newPagination";
import ViewContractReleaseAsset from "components/MetaData/Release/ViewContractReleaseAsset";
import ProjectsToContract from "./projectsToContract";
import DeleteDialogueBox from "components/Common/deleteDialogue";


export default function ProjectListing(contractDetails: any) {

    const [ProjectList, initProjectList] = useState<any[]>([]);
    const [contractRefNum, setContractRefNum] = useState<any[]>([]);
    const [totalRows, setTotalRows] = useState(1);
    console.log(contractDetails);


    useEffect(() => {
        getAffilate()
    }, []);


    const Data: any = { pageSize: 10, pageNumber: 1, contractRefNum: contractDetails?.contractDetails?.contractRefNum }

    const getAffilate = () => {
        projectServices.ProjectListing(Data).then((res) => {
            CommonUtilities.relativeDataRemapping(res.data, res.headers.original);
            setTotalRows(res.totalRows)
            console.log(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
            initProjectList(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
        })
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        console.log(Data);
        getAffilate()
    }

    let [viewContract, setviewContract] = useState(false);
    let [viewContractSelect, setviewContractSelect] = useState<any>([]);
    const ViewContractReleaseChange = (e: any) => {
        viewContract = false
        setviewContract(viewContract)
    }


    let [ProjectsToContractOpen, setProjectsToContractOpen] = useState(false);
    let [ProjectSelect, setProjectSelect] = useState<any>([]);
    const ProjectsToContractChange = (e: any) => {
        ProjectsToContractOpen = false
        setProjectsToContractOpen(ProjectsToContractOpen)
    }

    let [unlinkProjectStatus, setunlinkProjectStatus] = useState(false)
    let [unlinkProjectData, setunlinkProjectData] = useState<any>([]);
    const unlink_Project = () => {
        unlinkProjectStatus = true;
        setunlinkProjectStatus(unlinkProjectStatus)
    }

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {
            //true
            var payload = { assetType: "contract", assetCode: contractDetails?.contractDetails?.contractRefNum, projectId: "contract", projectList: unlinkProjectData.projectId }

            projectServices.unlinkProjectContract(payload).then((respond: any) => {
                //projectList();
            })
        }
        unlinkProjectStatus = false;
        setunlinkProjectStatus(unlinkProjectStatus)
    }


    return (

        <div className="ws-12">
            <div className="box-content p0">
                <div className="ws-12 pm">
                    <h3 className="capitalize mb pull-left ws-5 ptl">  Associated projects ({totalRows})  </h3>
                    <button className="icon-btn edit pull-right height35 width100" onClick={() => setProjectsToContractOpen(true)}> Copy</button>
                </div>

                <table className="newTable">
                    <thead>
                        <tr>
                            <th>Contact</th>
                            <th>Contact Code</th>
                            <th>Project Name</th>
                            <th>Project Code</th>
                            <th>Project License Type</th>
                            <th>Project Status</th>
                            <th className="text-bold ">Operations</th>
                        </tr>
                    </thead>
                    <tbody>

                        {

                            ProjectList.map(post => (
                                <tr>
                                    <td>{post.kontactDisplay}
                                        <button className="icon-btn info btn-xs pull-right" onClick={() => { setviewContract(true); setviewContractSelect(post) }}>
                                            <i className="icon-price-list"></i>
                                        </button>
                                    </td>
                                    <td>{post.kontactCode}</td>
                                    <td>{post.projectName}</td>
                                    <td>{post.projectCode}</td>
                                    <td></td>
                                    <td></td>
                                    <td >
                                        <button className="icon-btn edit btn-sm hide" >Move</button>
                                        <button className="icon-btn warning btn-sm" onClick={() => { unlink_Project(); setunlinkProjectData(post) }}>Unlink</button>

                                    </td>
                                </tr>

                            ))
                        }
                    </tbody>
                </table>

                {(() => {

                    if (totalRows > 1 && totalRows > 10) {
                        return <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />
                    }

                    if (totalRows === 0) {
                        return <div className="alert alert-info mtxl mrl mbl"> No data to display</div>
                    }
                })()}
            </div>

            {
                (() => {

                    if (viewContract) {
                        return <ViewContractReleaseAsset ViewContractReleaseChange={ViewContractReleaseChange} type="projects" viewContract={viewContract} viewContractSelect={viewContractSelect} />
                    }

                    if (ProjectsToContractOpen) {
                        return <ProjectsToContract ProjectsToContractOpen={ProjectsToContractOpen} ProjectsToContractChange={ProjectsToContractChange} contractDetails={contractDetails?.contractDetails} />
                    }

                    if (unlinkProjectStatus) {
                        return <DeleteDialogueBox param={unlinkProjectStatus} message={"to unlink this project from " + contractDetails?.contractDetails?.contractRefNum} onChange={Confirmation} />
                    }


                })()
            }
        </div>
    )


}